module.exports = __webpack_public_path__ + "static/concept5-sp-bb08a8ad226bbb9ca2bda8a6c2268fe1.svg";